// extracted by mini-css-extract-plugin
module.exports = {"comingSoonDiv":"ComingSoonComponent_comingSoonDiv__33YdB"};